import { UserStatusDescriptionEnum, UserStatusEnum } from 'api/users/users.enum';
import {
  UsersUsernameSortEnum,
  UsersFullNameSortEnum,
  UsersQueryKeysEnum,
  QueryKeyLocalStorageEnum,
} from 'context/query/queryContext/QueryContext.enum';
import { useLocale } from 'hooks/useLocale/useLocale';
import {
  YesNoFilterItemsDescriptionEnum,
  useYesNoFilterItems,
} from 'hooks/useYesNoHeaderFilterItems/useYesNoFilterItems';
import { AppMessages } from 'i18n/messages';
import { StatusTableItem } from 'ui/statusTableItem/StatusTableItem';
import { Table } from 'ui/table/Table';

export const UsersTableHeader = () => {
  const { formatMessage } = useLocale();
  const { yesNoFilterItems } = useYesNoFilterItems();

  return (
    <>
      <Table.HeaderSortItem
        queryKey={QueryKeyLocalStorageEnum.USERS}
        sortBy={UsersUsernameSortEnum}
        queryHeader={formatMessage({ id: AppMessages['users.table.header.name'] })}
      />

      <Table.HeaderSortItem
        queryKey={QueryKeyLocalStorageEnum.USERS}
        sortBy={UsersFullNameSortEnum}
        queryHeader={formatMessage({ id: AppMessages['users.table.header.fullName'] })}
      />

      <Table.HeaderFilterItem
        queryKey={QueryKeyLocalStorageEnum.USERS}
        queryName={UsersQueryKeysEnum.LOGGED}
        filterItems={yesNoFilterItems}
        queryHeader={formatMessage({ id: AppMessages['users.table.header.logged'] })}
        queryHeaderDescriptions={YesNoFilterItemsDescriptionEnum}
        maxWidth="300px"
      />

      <Table.HeaderFilterItem
        queryKey={QueryKeyLocalStorageEnum.USERS}
        queryName={UsersQueryKeysEnum.STATUS}
        filterItems={Object.values(UserStatusEnum).map((status) => ({
          name: <StatusTableItem status={status} />,
          filterBy: status,
        }))}
        queryHeader={formatMessage({ id: AppMessages['users.table.header.status'] })}
        queryHeaderDescriptions={UserStatusDescriptionEnum}
      />
    </>
  );
};
